import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Icon } from 'legacy-packages/ft-cb';
import IconWithDescription from '../index';

import './styles.scss';

export const TOOLTIP_CONTENT = {
  QUESTION:
    'This question is now available to students so they can practice for the at-home AP exam on their own.',
  QUIZ: 'These questions are now available as optional practice for students to answer on their own.',
  TAB: 'These questions are now available as optional practice for students to answer on their own.',
};

/**
 * Component for displaying the icon and the tooltip
 * for a FRQ Practice question/assessment.
 * */
const StudentPracticeIcon = ({
  iconClass,
  popoverClass,
  isQuestion,
  isTab,
}) => {
  const { QUESTION, QUIZ, TAB } = TOOLTIP_CONTENT;
  const tooltipContent = (isQuestion && QUESTION) || (isTab && TAB) || QUIZ;
  const popoverTrigger = (
    <Icon
      data-test-id="student-practice-icon-popover-trigger"
      className={cn({ [iconClass]: !!iconClass })}
      name="target"
      size="1.25em"
    />
  );

  return (
    <IconWithDescription
      className={cn({ [popoverClass]: !!popoverClass })}
      width="medium"
      trigger={popoverTrigger}
      popoverAriaLabel="student-frq-practice"
      tooltipAriaLabel={tooltipContent}
    >
      <span data-test-id="student-practice-icon-tooltip">{tooltipContent}</span>
    </IconWithDescription>
  );
};

StudentPracticeIcon.displayName = 'StudentPracticeIcon';

StudentPracticeIcon.props = {
  // CSS class for styling the icon
  iconClass: PropTypes.string,
  // CSS class for styling the popover.
  popoverClass: PropTypes.string,
  // Flag for setting the tooltip content for a question or for a quiz.
  isQuestion: PropTypes.bool,
  // Flag for showing the tooltip for a tab.
  isTab: PropTypes.bool,
};

StudentPracticeIcon.defaultProps = {
  iconClass: null,
  popoverClass: null,
  isQuestion: false,
  isTab: false,
};

export default StudentPracticeIcon;
